<template>
  <div class="flex flex-col gap-4" data-testid="archive-project-detail">
    <div v-if="project" class="surface-card border-round p-4">
      <div class="flex flex-col gap-1">
        <h2 class="text-xl font-semibold text-[var(--color-dark)]">{{ project.name }}</h2>
        <p v-if="project.description" class="text-sm text-[var(--color-disabled)]">
          {{ project.description }}
        </p>
        <p class="text-sm text-[var(--color-disabled)]">
          {{ $t('ProjectManagement.archivedProjects.detail.subtitle', { date: formatDate(project.startDate) }) }}
        </p>
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4" data-testid="archive-summary-strip">
      <div class="surface-card border-round p-4 flex flex-col gap-2 min-h-[6.5rem]">
        <span class="text-xs font-medium uppercase tracking-wide text-[var(--color-disabled)]">
          {{ $t('ProjectManagement.archivedProjects.summary.commitments') }}
        </span>
        <span class="text-2xl font-semibold text-[var(--color-dark)]">
          {{ summary.commitmentsDone }} / {{ summary.commitmentsTotal }}
        </span>
        <span class="text-sm text-[var(--color-disabled)]">
          {{ $t('ProjectManagement.archivedProjects.summary.notDone', { count: summary.commitmentsNotDone }) }}
        </span>
      </div>

      <div class="surface-card border-round p-4 flex flex-col gap-2 min-h-[6.5rem]">
        <span class="text-xs font-medium uppercase tracking-wide text-[var(--color-disabled)]">
          {{ $t('ProjectManagement.archivedProjects.summary.constraints') }}
        </span>
        <span class="text-2xl font-semibold text-[var(--color-dark)]">
          {{ summary.constraintsResolved }} / {{ summary.constraintsTotal }}
        </span>
      </div>

      <div class="surface-card border-round p-4 flex flex-col gap-2 min-h-[6.5rem]">
        <span class="text-xs font-medium uppercase tracking-wide text-[var(--color-disabled)]">
          {{ $t('ProjectManagement.archivedProjects.summary.decisions') }}
        </span>
        <span class="text-2xl font-semibold text-[var(--color-dark)]">
          {{ summary.decisionsDecided }} / {{ summary.decisionsTotal }}
        </span>
      </div>

      <div class="surface-card border-round p-4 flex flex-col gap-2 min-h-[6.5rem]">
        <span class="text-xs font-medium uppercase tracking-wide text-[var(--color-disabled)]">
          {{ $t('ProjectManagement.archivedProjects.summary.milestones') }}
        </span>
        <span class="text-2xl font-semibold text-[var(--color-dark)]">
          {{ summary.milestonesDone }} / {{ summary.milestonesTotal }}
        </span>
      </div>
    </div>

    <Tabs value="commitments">
      <TabList>
        <Tab value="commitments">{{ $t('ProjectManagement.archivedProjects.tabs.commitments') }}</Tab>
        <Tab value="constraints">{{ $t('ProjectManagement.archivedProjects.tabs.constraints') }}</Tab>
        <Tab value="decisions">{{ $t('ProjectManagement.archivedProjects.tabs.decisions') }}</Tab>
        <Tab value="milestones">{{ $t('ProjectManagement.archivedProjects.tabs.milestones') }}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel value="commitments">
          <ArchiveEntityTable entity="commitments" :rows="commitments" />
        </TabPanel>
        <TabPanel value="constraints">
          <ArchiveEntityTable entity="constraints" :rows="constraints" />
        </TabPanel>
        <TabPanel value="decisions">
          <ArchiveEntityTable entity="decisions" :rows="decisions" />
        </TabPanel>
        <TabPanel value="milestones">
          <ArchiveEntityTable entity="milestones" :rows="milestones" />
        </TabPanel>
      </TabPanels>
    </Tabs>
  </div>
</template>

<script>
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import ArchiveEntityTable from './ArchiveEntityTable.vue';

export default {
  name: 'ArchiveProjectDetail',
  components: {
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    ArchiveEntityTable,
  },
  props: {
    project: {
      type: Object,
      default: null,
    },
    summary: {
      type: Object,
      required: true,
    },
    commitments: {
      type: Array,
      default: () => [],
    },
    constraints: {
      type: Array,
      default: () => [],
    },
    decisions: {
      type: Array,
      default: () => [],
    },
    milestones: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatDate(value) {
      if (!value) return '—';
      return new Date(value).toLocaleDateString();
    },
  },
};
</script>
